export default __webpack_public_path__ + "static/documents-why-image-f78dd445ed94165d5eae5b353cea0f26.webp";